import { render, staticRenderFns } from "./selectMention.vue?vue&type=template&id=5ab09a72"
import script from "./selectMention.vue?vue&type=script&lang=js"
export * from "./selectMention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab09a72')) {
      api.createRecord('5ab09a72', component.options)
    } else {
      api.reload('5ab09a72', component.options)
    }
    module.hot.accept("./selectMention.vue?vue&type=template&id=5ab09a72", function () {
      api.rerender('5ab09a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/formOverlay/selectMention.vue"
export default component.exports